var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoEquipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 8.125,
    viewBox: "0 0 37.5 28.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-equipment",
    d: "M17.813-4.687H15V-20.625a3.754,3.754,0,0,0-3.75-3.75h-22.5A3.754,3.754,0,0,0-15-20.625V-4.687h-2.812a.937.937,0,0,0-.937.938V-.937A4.693,4.693,0,0,0-14.062,3.75H14.063A4.693,4.693,0,0,0,18.75-.937V-3.75A.937.937,0,0,0,17.813-4.687ZM-13.125-20.625A1.875,1.875,0,0,1-11.25-22.5h22.5a1.875,1.875,0,0,1,1.875,1.875V-4.687H4.168a.492.492,0,0,0-.464.415,1.876,1.876,0,0,1-1.829,1.46h-3.75A1.876,1.876,0,0,1-3.7-4.272a.492.492,0,0,0-.464-.415h-8.957Zm30,19.688a2.816,2.816,0,0,1-2.812,2.813H-14.062A2.816,2.816,0,0,1-16.875-.937V-2.812H-5.464A2.816,2.816,0,0,0-2.812-.937H2.813A2.815,2.815,0,0,0,5.464-2.812H16.875Z",
    transform: "translate(18.75 24.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEquipment);
export default __webpack_public_path__ + "static/media/ico-equipment.68fe859429e703ee7daffc2aa8d1424f.svg";
export { ForwardRef as ReactComponent };